import type { SliceCreator, UiActions } from './types';
import { INITIAL_STATE } from './types';

export const createUiSlice: SliceCreator<UiActions> = (set) => ({
  // Leaving floating drops any bridge path so it can't re-trigger the
  // auto-close after the widget is already dismissed / re-opened elsewhere.
  setMode: (mode) =>
    set((s) => ({
      mode,
      floatingBridgePath: mode === 'floating' ? s.floatingBridgePath : null,
    })),

  openFloatingBridge: (path) =>
    set({ mode: 'floating', floatingBridgePath: path }),

  toggleHistory: (open) =>
    set((s) => ({ historyOpen: open ?? !s.historyOpen })),

  openDraft: () =>
    set({ draftOpen: true, activeSessionId: null, mode: 'floating' }),

  closeDraft: () => set({ draftOpen: false }),

  reset: () => set(INITIAL_STATE),

  setWsReconnecting: (reconnecting) =>
    set((s) =>
      s.wsReconnecting === reconnecting ? s : { wsReconnecting: reconnecting }
    ),

  setUploadProgress: (sessionId, turnId, progress) =>
    set((s) => {
      const current = s.uploadProgressBySession[sessionId];
      if (progress === null) {
        if (!current || current.turnId !== turnId) return s;
        const next = { ...s.uploadProgressBySession };
        delete next[sessionId];
        return { uploadProgressBySession: next };
      }
      // A late XMLHttpRequest callback from turn A cannot overwrite turn B.
      if (s.activeTurnsBySession[sessionId]?.turnId !== turnId) return s;
      if (current?.turnId === turnId && current.progress === progress) return s;
      return {
        uploadProgressBySession: {
          ...s.uploadProgressBySession,
          [sessionId]: { turnId, progress },
        },
      };
    }),

  openProfile: (candidate) => set({ profileCandidate: candidate }),

  closeProfile: () => set({ profileCandidate: null }),
});
